export default __webpack_public_path__ + "static/media/ford.716d1606.png";